// export const API_URL = 'http://localhost:8081/api/v1';
// export const API_URL = 'https://embed.pdffillers.com/app/api/v1';
// export const API_URL = 'https://embed.pdffiller.com/app/api/v1';
// export const API_URL = 'https://embed.pdffiller-rc.xyz/app/api/v1';
export const getApiUrl = () => {
  console.log('**** process.env.API_URL', process.env.API_URL);
  return process.env.API_URL;
};
